import { useMutation } from "urql";

import { UnFreezeCustomerDocument } from "../../../graphql/generated.ts";

export const useUnFreezeCustomerStatus = () =>
  useMutation(UnFreezeCustomerDocument);
